import type { ColumnSort } from '@tanstack/react-table';

import type { ArtistTracksSortBy } from '~/modules/artist-roster/types';

export function formatArtistTracksSortBy(
  columnSort?: ColumnSort,
): ArtistTracksSortBy {
  const columnId = columnSort?.id;
  const sortDirection = columnSort?.desc ? '-' : '+';

  if (columnId === 'initialReleaseDate') {
    return `${sortDirection}EARLIEST_RELEASE_DATE`;
  }

  if (columnId === 'title') {
    return `${sortDirection}GROUPING_TITLE`;
  }

  return '';
}
